// Translation: Utility > Loading error (English)
export default Object.freeze({
	description: 'This is usually temporary. Please try again in a moment.',
	title: 'Unable to load your account'
})
